import fetch from 'node-fetch';

type NewSubscriptionData = {
  client_name: string;
  client_email: string;
  trainer_id: string;
  client_phone: string;
  paypal_data: any;
};

type VerifyOtpData = {
  client_phone: string
  phone_verification_key: string
}

type UpdatePhoneNumber = {
  client_phone: string
  subscription_id: string
}

const TOKEN = 'qQFFFZGCo1dUqpAgnaEQgzvovTuenUFVIkVKmEvR'

const formatPhoneNumber = (phoneNumber:string) => {
  return phoneNumber.includes('+') ? phoneNumber : `+${phoneNumber}`
}

export const newSubscription = async (data: NewSubscriptionData) => {
  const phone = formatPhoneNumber(data.client_phone)
  return await fetch(
    `${process.env.GATSBY_API_URL}/coachapi/trainer/subscription`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Token: TOKEN,
      },
      body: JSON.stringify({...data, client_phone: phone}),
    }
  );
};

export const verifyPhone = async (data: VerifyOtpData) => {
  const phone = formatPhoneNumber(data.client_phone)
  return await fetch(
    `${process.env.GATSBY_API_URL}/coachapi/trainer/subscription/verify_phone`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Token: TOKEN,
      },
      body: JSON.stringify({...data, client_phone: phone}),
    }
  );
};

// will resend the otp code the client
export const updatePhoneNumber = async (data: UpdatePhoneNumber) => {
  const phone = formatPhoneNumber(data.client_phone)
  return await fetch(
    `${process.env.GATSBY_API_URL}/coachapi/trainer/subscription/update_phone`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Token: TOKEN,
      },
      body: JSON.stringify({...data, client_phone: phone}),
    }
  );
};
